module.exports = __webpack_public_path__ + "static/media/HomeNavIconActive.26a224b6.svg";